class SchedulerHeader {
  constructor() {}
}

angular.module('capability-ng-scheduler').component('schedulerHeader', {
  templateUrl: 'capability-ng-scheduler/src/components/scheduler_header/scheduler_header.html',
  controller: SchedulerHeader
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/scheduler_header/scheduler_header.ts